import { ReactNode, useState } from "react";
import { Affix, Menu, MenuProps } from "@mantine/core";
import { useClickOutside } from "@mantine/hooks";

export interface ContextMenuProps {
  target: ReactNode;
  dropdown: ReactNode;
  menuProps?: MenuProps;
}

type ContextCoords = {
  clientX: number | null;
  clientY: number | null;
};

/**
 * Menu that opens on right click. Base is Mantine's Menu component
 * @param target - ReactNode that when right clicked will open the menu
 * @param dropdown - ReactNode that will be rendered in the Menu (should include `Menu.Item`s)
 * @param menuProps - optional props to pass to the mantine Menu component
 */
export const ContextMenu: React.FC<ContextMenuProps> = ({
  target,
  dropdown,
  menuProps,
}) => {
  const [coords, setCoords] = useState<ContextCoords>({
    clientX: null,
    clientY: null,
  });
  const ref = useClickOutside(() =>
    setCoords({ clientX: null, clientY: null })
  );
  const validCoords = coords.clientX !== null && coords.clientY !== null;

  return (
    <div>
      <div
        onContextMenu={(e) => {
          e.preventDefault();
          const { clientX, clientY } = e;
          setCoords({ clientX, clientY });
        }}
      >
        {target}
      </div>
      <Affix
        sx={{ display: validCoords ? "initial" : "none" }}
        position={
          validCoords
            ? { top: coords.clientY!, left: coords.clientX! }
            : undefined
        }
      >
        <Menu {...menuProps} opened={validCoords}>
          <div ref={ref}>
            <Menu.Dropdown>{dropdown}</Menu.Dropdown>
          </div>
        </Menu>
      </Affix>
    </div>
  );
};
